'use client';

import { useContext } from 'react';

import { AuthenticationContext } from '../contexts/authentication-context';
import { User } from '../models/user.model';

export interface UseAuthenticationValue {
   user: User | undefined;
   loading: boolean;
   accessToken: string | undefined;
   login: (redirectUrl?: string) => void;
   refreshToken: () => Promise<void>;
   logout: () => void;
}

export const useAuthentication = (): UseAuthenticationValue => {
   const context = useContext(AuthenticationContext);
   if (!context) {
      throw new Error('useAuthenticationContext must be used within a AuthenticationContextProvider');
   }
   return context;
};
